import { createSelector } from 'reselect'
import adminOnboardingGetIsTrialFromSFSelector from 'redux/selectors/admin_onboarding/admin_onboarding_is_trial_from_sf_selector'

const getAdminOnboardingData = state => state.adminOnboarding

const showLastStepAdminOnboarding = createSelector(
	[getAdminOnboardingData, adminOnboardingGetIsTrialFromSFSelector],
	(adminOnboarding, isTrialFromSFData) => ({
		showLastStep: adminOnboarding.showLastStep,
		redirectAfterRefer: adminOnboarding.redirectAfterRefer,
		redirectAfterCongrats: adminOnboarding.redirectAfterCongrats,
		isAdmin: adminOnboarding.isAdmin,
		isTrialFromSF: isTrialFromSFData.isTrialFromSF,
	})
)

export default showLastStepAdminOnboarding
